import { co2 } from './common';

export default {
  'consumption.co2': `${co2} losun í blönduðum akstri`,
  'consumption.energy': 'Orkunotkun í prófunarferli í blönduðum akstri',
  'consumption.fuel': 'Eldsneytisnotkun í blönduðum akstri',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc':
    'Tölurnar byggja á niðurstöðum úr stöðluðu mælingaferli. Þær innihalda „NEDC CO2 values" skv. 2. gr. 1. reglugerðar (ESB) 2017/1153. Tölur um eldsneytisnotkun hafa verið reiknaðar út frá þessum gildum. Rafmagnsnotkun hefur verið ákvörðuð á grundvelli tilskipunar 692/2008/ EB.',
  'footnotes.emissions.appendix':
    'Nánari upplýsingar um eldsneytisnotkun og CO2 losun nýrra fólksbíla fást hjá viðurkenndum Mercedes-Benz söluaðila.',
  'search.input.label': 'Leitarorð þitt / OnlineCode stillingar',
  'search.result.buy-online': 'Kaupa á netinu',
  'search.results.count': '{count} leitarniðurstaða',
  'search.results': 'Engin leitarniðurstaða | {count} leitarniðurstaða | {count} leitarniðurstaða',
  'search.results.backup': 'Engin nákvæm samsvörun fannst. Skoða tengdar síður:',
  'search.results.none.summary':
    'Engar leitarniðurstöður eru tiltækar fyrir þetta leitarorð. Reyndu aftur með öðru leitarorði.',
  'search.show-more': 'Sýna fleiri niðurstöður',
  'search.unavailable': 'Leit er ekki í boði eins og er.',
  'search.result.new': 'Nýr',

  'input.placeholder': 'Leitarorð þitt / OnlineCode stillingar',

  'suggestions.all_search_results': 'Allar leitarniðurstöður',
  'suggestions.all_search_results_for': 'Sýna allar niðurstöður fyrir',
  'suggestions.in': 'í',

  all: 'Allt',
  UCOS: 'Used vehicle Online Store',
  PASSENGER_CARS: 'Fólksbílar',
  VANS: 'Atvinnubílar',
  NCOS: 'New vehicle Online Store',
  VIDEO: 'Myndbönd',
  DEALER_LOCATOR: 'Sölu- og þjónustuaðilar',
  CONFIGURATOR: 'Reynsluakstur',
  TEST_DRIVE: 'Reynsluakstur',
  VEHICLE_SEARCH: 'Leit á notuðum bílum',
  COLLECT: 'Gjafavara og aukahlutir',
  CONNECT: 'Mercedes me ',

  'search.result.consumption': 'Neysla',
  'watch.video': 'Horfðu á myndbandið',
  'input.recently': 'Nýlega leitað',
  'input.help.title': 'Hverju er hægt aj leita að?',
  'input.help.text':
    'Hægt er að leita frá bílategund, bíltegund og skráningarnúmeri eða leita að aukahlutum, öðrum vörum og upplýsingum',

  'search.result.grid': 'Grid',
  'search.result.list': 'List',

  // Empty result
  'support.check': 'Athugaðu með innsláttarvillur eða reyndu aftur með öðru leitarorði.',
  'support.no.results': 'Engar leitarniðurstöður eru í boði fyrir þetta leitarorð.',
  'support.no.results.term': 'Leitin skilaði engum niðurstöðum.',
  'support.chat': 'Finnurðu ekki það sem þú ert að leita að? Notaðu þá okkar leit. ',
  'support.chat.with.us': 'Netspjall.',
};
